import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { FaMinus, FaPlus } from 'react-icons/fa'

const HelpPage = () => {
    const [open, setOpen] = useState(false);
    const [openone, setOpenone] = useState(false);
    const [opentwo, setOpentwo] = useState(false);
    const [openthree, setOpenthree] = useState(false);
    const [openfour, setOpenfour] = useState(false);
    const [opensix, setOpensix] = useState(false);
    const [openseven, setOpenseven] = useState(false);
    const [openeight, setOpeneight] = useState(false);
    const [opennine, setOpennine] = useState(false);
    const [openten, setOpenten] = useState(false);
    const [opentwelve, setOpentwelve] = useState(false);
    const [openthirteen, setOpenthirteen] = useState(false);
    const [openforteen, setOpenforteen] = useState(false);
    const [openfifteen, setOpenfifteen] = useState(false);
    const [opensixteen, setOpensixteen] = useState(false);
    const [openseventeen, setOpenseventeen] = useState(false);

    const handleShowClickfour = () => {
        setOpenfour(!openfour);
    };
   
    const handleShowClicksix = () => {
        setOpensix(!opensix);
    };
    const handleShowClickseven = () => {
        setOpenseven(!openseven);
    };

    const handleShowClickeight = () => {
        setOpeneight(!openeight);
    };

    const handleShowClicknine = () => {
        setOpennine(!opennine);
    };

    const handleShowClickten = () => {
        setOpenten(!openten);
    };

    const handleShowClicktwelve = () => {
        setOpentwelve(!opentwelve);
    };

    const handleShowClickthirteen = () => {
        setOpenthirteen(!openthirteen);
    };

    const handleShowClickforteen = () => {
        setOpenforteen(!openforteen);
    };

    const handleShowClickfifteen = () => {
        setOpenfifteen(!openfifteen);
    };
    const handleShowClicksixteen = () => {
        setOpensixteen(!opensixteen);
    };
    const handleShowClickseventeen = () => {
        setOpenseventeen(!openseventeen);
    };
    return (
        <>
            <div className="overflow-auto" style={{ height: "calc(100vh - 140px" }}>
                <div className="question-container">
                    <h1 className="main-header">Frequently Asked Question</h1>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${open ? "fw-bold" : ""}`}
                            >
                                What is new in the online version?
                            </span>
                            {open ? (
                                <FaMinus onClick={() => setOpen(!open)} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={() => setOpen(!open)}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={open}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        The online feature of MXPlayer gives you access to online
                                        content which is catered for all our Indian users across
                                        different genres. From popular TV shows, movies, music, and
                                        shorts across different genres like lifestyle, health, gossip
                                        and much more.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openone ? "fw-bold" : ""}`}
                            >
                                Is this available outside India?
                            </span>
                            {openone ? (
                                <FaMinus onClick={() => setOpenone(!openone)} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={() => setOpenone(!openone)}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openone}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Currently, the online streaming feature of MXPlayer is only available in India.
                                        So, if you are outside India, you will not be able to access the same.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${opentwo ? "fw-bold" : ""}`}
                            >
                                Will online feature ever be available outside India?
                            </span>
                            {opentwo ? (
                                <FaMinus onClick={() => setOpentwo(!opentwo)} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={() => setOpentwo(!opentwo)}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={opentwo}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        We are thinking of expanding our boundaries in the future. However, giving a timeline for now will not be possible.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openthree ? "fw-bold" : ""}`}
                            >
                                Can I download videos to watch them offline?
                            </span>
                            {openthree ? (
                                <FaMinus onClick={() => setOpenthree(!openthree)} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={() => setOpenthree(!openthree)}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openthree}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Currently, we do not have the option to download online videos on our platform.
                                        However, it is in the pipeline and you can see the same the in the near future.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openfour ? "fw-bold" : ""}`}
                            >
                                Is it Free or do I need to pay for the online feature?
                            </span>
                            {openfour ? (
                                <FaMinus onClick={handleShowClickfour} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickfour}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openfour}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        The online Feature of MXPlayer is available absolutely free of cost for our users to explore.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    {/* <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openfive ? "fw-bold" : ""}`}
                            >
                                The online videos are buffering, but I have a good network speed. What should I do?
                            </span>
                            {openfive ? (
                                <FaMinus onClick={handleShowClickfive} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickfive}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openfive}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        There are multiple factors (apart from internet speed) that affect the streaming experience like latency, routing etc. So we request you to clear the App/Browser cache and try again. If the issue persists, please write to us at support@j2apps.com.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div> */}
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${opensix ? "fw-bold" : ""}`}
                            >
                                What are the devices would I will be able to user the online streaming feature on?
                            </span>
                            {opensix ? (
                                <FaMinus onClick={handleShowClicksix} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClicksix}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={opensix}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Currently, you can access the our Online streaming feature across all Android and iOS devices. Also, you can check our website www.mxplayer.in
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openseven ? "fw-bold" : ""}`}
                            >
                                What are the devices would I will be able to user the online streaming feature on?
                            </span>
                            {openseven ? (
                                <FaMinus onClick={handleShowClickseven} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickseven}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openseven}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Currently, you can access the our Online streaming feature across all Android and iOS devices. Also, you can check our website www.mxplayer.in
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openeight ? "fw-bold" : ""}`}
                            >
                                Will I be able to watch online videos on my Smart TV?
                            </span>
                            {openeight ? (
                                <FaMinus onClick={handleShowClickeight} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickeight}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openeight}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        We are working on making our platform available on Smart TVs and externally connected devices like Amazon firestick, Google Chromecast etc.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>

                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${opennine ? "fw-bold" : ""}`}
                            >
                                What are the supported browsers for your website?
                            </span>
                            {opennine ? (
                                <FaMinus onClick={handleShowClicknine} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClicknine}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={opennine}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Our Website is currently supported on the following laptop/desktop browsers:

                                        1. Google Chrome
                                        2. Mozilla Firefox
                                        3. Safari
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>

                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openten ? "fw-bold" : ""}`}
                            >
                                Will I be able to access your website on mobile browsers?

                            </span>
                            {openten ? (
                                <FaMinus onClick={handleShowClickten} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickten}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openten}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Yes, you will be able to access our website on your mobile browser. Moreover, the website is currently supported in the following mobile browsers:
                                        <ul>
                                            <li> Google Chrome</li>
                                            <li> Mozilla Firefox</li>
                                            <li>Safari</li>
                                            <li>UC Browser</li>
                                        </ul>

                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${opentwelve ? "fw-bold" : ""}`}
                            >
                                Will I be able to access your services (App/Website) using a VPN outside India?

                            </span>
                            {opentwelve ? (
                                <FaMinus onClick={handleShowClicktwelve} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClicktwelve}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={opentwelve}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        No, since our online feature is not available outside India, you will not be able to access our online content using VPN.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    {/* <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openeleven ? "fw-bold" : ""}`}
                            >

                                Do I need to sign up on MX Player to stream?

                            </span>
                            {openeleven ? (
                                <FaMinus onClick={handleShowClickeleven} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickeleven}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openeleven}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        The content available on MX Player can be streamed without signing up.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div> */}
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openthirteen ? "fw-bold" : ""}`}
                            >

                                Can MX Original web shows be streamed for free?

                            </span>
                            {openthirteen ? (
                                <FaMinus onClick={handleShowClickthirteen} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickthirteen}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openthirteen}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Yes, the MX Originals’ web shows streaming online on MX Player can be watched for free and without signing up.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openforteen ? "fw-bold" : ""}`}
                            >

                                Is MX Player only available in India?

                            </span>
                            {openforteen ? (
                                <FaMinus onClick={handleShowClickforteen} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickforteen}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openforteen}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        The online streaming service of MX Player is only available in India. Access to the online content is not available outside India.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openfifteen ? "fw-bold" : ""}`}
                            >

                                Can I watch the videos without the subscription?

                            </span>
                            {openfifteen ? (
                                <FaMinus onClick={handleShowClickfifteen} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickfifteen}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openfifteen}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        Yes, the videos can be streamed by the users online on MX Player without the subscription.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${opensixteen ? "fw-bold" : ""}`}
                            >

                                How can I sign up on MX Player?

                            </span>
                            {opensixteen ? (
                                <FaMinus onClick={handleShowClicksixteen} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClicksixteen}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={opensixteen}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        You can sign up on MX Player using your facebook account, Google account or using your phone number.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="question">
                        <div className="question-header">
                            <span
                                className={`question-main ${openseventeen ? "fw-bold" : ""}`}
                            >

                                What websites can I watch free movies?
                            </span>
                            {openseventeen ? (
                                <FaMinus onClick={handleShowClickseventeen} style={{ color: "blue", cursor: "pointer" }} />
                            ) : (
                                <FaPlus onClick={handleShowClickseventeen}
                                />
                            )}
                        </div>
                        <div className="w-100 fs-13">
                            <Collapse in={openseventeen}>
                                <div className="mb-4">
                                    <span
                                        className="text-white fs-16"
                                        style={{ wordSpacing: 2 }}
                                    >
                                        MX Player website allows the users to watch Hindi movies and movies in regional languages available on its website like Kannada,
                                        Tamil, Telugu, Gujarati and other languages for free.
                                    </span>
                                </div>
                            </Collapse>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default HelpPage